import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  dialogPaper: {
    minHeight: 453,
  },
}));

export default useStyles;
